import { render, staticRenderFns } from "./RealizarConsulta.vue?vue&type=template&id=3a6673bb&"
import script from "./RealizarConsulta.vue?vue&type=script&lang=js&"
export * from "./RealizarConsulta.vue?vue&type=script&lang=js&"
import style0 from "./RealizarConsulta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports